/**
 * The self-improve endpoint is synchronous and one iteration may already
 * contain several model/data-source calls. Keep each explicit click within
 * the reverse proxy request window; the user can run another pass if needed.
 */
export const SELF_IMPROVE_MAX_ITERATIONS = 1

export function isSelfImproveTimeout(error: unknown): boolean {
  return (error as { response?: { status?: unknown } }).response?.status === 504
}
